import LTR from "@brand-icons/ploom/device-bluetooth/device-bluetooth-ltr.svg";

import { iconFactory } from "../iconFactory";

export const DeviceBluetoothIcon = iconFactory("DeviceBluetoothIcon", LTR);
